import React from 'react';
import { fonts, heights, widths } from './../../styles/theme.json';

const Headline = (props) => {
  return (
    <h1 className={props.color}>
      {props.children}
      <style jsx>{`
        h1 {
          font-family: ${fonts.mallory_bold};
          font-size: ${fonts.h1_size};
          letter-spacing: .2rem;
          color: #000;
          text-transform: uppercase;
        }
        .black {
          color: #000;
        }
        .white {
          color: #fff;
        }
      `}</style>
    </h1>
  );
};

export default Headline;



// WEBPACK FOOTER //
// ./src/components/dom-elements/Headline.js